import React from 'react';
import { Head, Link, usePage } from '@inertiajs/react';
import { PublicLayout } from '@/components/PublicLayout';

interface Newsletter {
  id: number;
  name: string;
  slug: string;
}

interface Issue {
  id: number;
  subject: string;
  issue_number: number | null;
  sent_at: string | null;
  preheader: string | null;
  content: string | null;
}

interface Props {
  newsletter: Newsletter;
  issue: Issue;
}

export default function NewsletterIssueShow({ newsletter, issue }: Props) {
  const { auth } = usePage().props as { auth?: { user?: { id: number; email: string; name: string } } };
  const user = auth?.user;

  const formatDate = (dateString: string | null): string => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <PublicLayout user={user}>
      <Head title={`${issue.subject} - ${newsletter.name}`} />
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <Link
              href={`/newsletters/${newsletter.slug}`}
              className="text-decoration-none mb-3 d-inline-block"
            >
              ← Back to {newsletter.name}
            </Link>

            <article>
              <header className="mb-4">
                {issue.issue_number && (
                  <span className="badge bg-secondary me-2">
                    Issue #{issue.issue_number}
                  </span>
                )}
                {issue.sent_at && (
                  <small className="text-muted d-block mb-2">
                    {formatDate(issue.sent_at)}
                  </small>
                )}
                <h1>{issue.subject}</h1>
                {issue.preheader && (
                  <p className="lead text-muted">{issue.preheader}</p>
                )}
              </header>

              <hr />

              {issue.content ? (
                <div
                  className="newsletter-content"
                  dangerouslySetInnerHTML={{ __html: issue.content }}
                />
              ) : (
                <div className="alert alert-warning">
                  This issue has no content available.
                </div>
              )}
            </article>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
}
